
  <!-- 我的规划 -->
<template>
  <div class="myplan-main-box">
    <banner ref="handleChandeData"></banner>
    <!-- tab -->
    <div class="myplan-main">
      <div class="choose-menu">
        <zlr-menu :menuList="menuList"></zlr-menu>
      </div>
      <div>
        <router-view @up-data="handleBannerData"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
// less
import './myplan.less'
// components
import Banner from './components/banner'
import ZlrMenu from '@/components/menu/menu-row'
export default {
  name: 'myplan-main',
  components: {
    Banner,
    ZlrMenu
  },
  data () {
    return {
      menuList: [
        {
          title: '待办事项',
          name: ['myplan-todo-tabs']
        },
        {
          title: '我的申请全览',
          name: ['myplan-overview-tabs']
        }
      ]
    }
  },
  computed: {},
  mounted () {},
  methods: {
    handleBannerData () {
      this.$refs.handleChandeData.getChildData()
    }
  }
}
</script>
<style lang='less'>
</style>
